export default "__VITE_ASSET__a863ee82__"